// frontend/modules/drafts/index.ts
import { ModuleConfig } from '@/core/module';
import { draftsRoutes } from './routes';
import { useDraftsStore } from './stores/drafts-store';
import { DraftProcessHandlerRegistry } from './types/handlers';

// Create and export the registry helper for easier access by other modules
export const getDraftHandlerRegistry = () => DraftProcessHandlerRegistry.getInstance();

export const DraftsModule: ModuleConfig = {
  name: 'drafts',
  routes: draftsRoutes,
  stores: {
    drafts: useDraftsStore
  },
  initialize: () => {
    console.log('Drafts module initialized');
    
    // Initialize the handler registry
    DraftProcessHandlerRegistry.getInstance();
    
    // In a real application, default handlers could be registered here
  }
};

// Export types for use by other modules
export * from './types';
